import {
  Bookmark,
  Heart,
  MessageCircle,
  MoreHorizontal,
  Send,
} from "lucide-react";

import { Avatar } from "@/components/avatar";

import type { ScheduledPost } from "../scheduledPost";

import { PostCaption } from "./PostCaption";
import { PostImage } from "./PostImage";

export function InstagramPostPreview({ post }: { post: ScheduledPost }) {
  return (
    <article
      aria-label="Instagram preview"
      className="overflow-hidden rounded-lg border border-border-secondary bg-bg-primary text-text-primary"
    >
      <div className="flex items-center gap-md p-md">
        <Avatar
          alt={post.account.name}
          className="size-8 rounded-full"
          initials={post.account.name.slice(0, 2).toUpperCase()}
        />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold">{post.account.name}</p>
          {post.account.location && (
            <p className="truncate text-xs text-text-tertiary">
              {post.account.location}
            </p>
          )}
        </div>
        <MoreHorizontal className="size-5 text-fg-quaternary" />
      </div>

      <PostImage post={post} />

      <div className="flex items-center justify-between p-md">
        <div className="flex gap-lg">
          <Heart className="size-6" />
          <MessageCircle className="size-6" />
          <Send className="size-6" />
        </div>
        <Bookmark className="size-6" />
      </div>

      <p className="px-md pb-md text-sm">
        <span className="font-semibold">{post.account.name}</span>{" "}
        <PostCaption caption={post.caption} />
      </p>
    </article>
  );
}
